import API from '@/services/http'

/** 获取新手任务 */
export const fetchGuideInfoApi = () => API.admin.post('/api/guide/task/list')
/* 新手任务step提示，不再提示 */
export const neverRemindApi = () => API.admin.post('/api/guide/task/close_remind')
/* 新手任务step提示，不再提示 */
export const finishStepByStep = () => API.admin.post('/api/guide/task/step_read', { guideTaskType: 'TRACK_SETTING_GUIDE_TASK' })
